import { CenterCostsView } from '../../lib/types/models/center/center-costs-view'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getCenterCostsView(id: number) {
  return restApiClient
    .url(constructApiUrl(API.centers.getCenterCostsView.url, { id }))
    .get<CenterCostsView>()
}
